import React, { useEffect, useState } from "react";
import "./configured_dashboard.scss";
import MetricCounter from "./metric_counter/metric_counter.jsx";
import DoughnutChart from "./active-tasks-bar-graph/active-str-bar-chart.jsx";
import WorkLoadWidget from "./work-load-widget/work-load-widget.jsx";
import NoFilingVsCompletedLineGraph from "./not-started-vs-completed/no-filing-vs-completed.jsx";
import NotStartedVsCompletedLineGraph from "./not-started-vs-completed/not-started-vs-completed.jsx";
import CompletedSTRsBarGraph from "./complete-tasks-bar-graph/completed-str-bar-graph.jsx";
import {
  fetchEndpointData,
  fetchbigNumbersWidgetData,
  fetchActiveSTRData,
  fetchSTRLineGraphData,
  fetchWorkLoadData,
  fetchSTRNoFilingVsCompleteLineGraphData,
  fetchCompletedSTRData,
  fetchAgeOfCaseData,
} from "../../../services/api/dashboard-api.js";
import { PulseLoader } from "react-spinners";
import dayjs from "../../../util/dayjs-config";
import { Helmet } from "react-helmet-async";
import AgeOfCasesLineGraph from "./not-started-vs-completed/age-of-cases.jsx";

const ConfiguredDashboard = () => {
  const [loading, setLoading] = useState({
    isLoading: true,
    isBigNumbersWidgetDataLoading: true,
    isActiveSTRDataLoading: true,
    isLineGraphLoading: true,
    isNoFilingVsCompletedLoading: true,
    isWorkLoadLoading: true,
    isCompletedSTRLoading: true,
    isAgeOfCaseLoading: true,
  });
  const [customDates, setCustomDates] = useState({
    customStart:
      localStorage.getItem('lineGraph_sort_start') === 'undefined' ||
      !localStorage.getItem('lineGraph_sort_start') ? dayjs().subtract(6, 'days').toDate() : new Date(localStorage.getItem('lineGraph_sort_start')),
    customEnd:
      localStorage.getItem('lineGraph_sort_end') === 'undefined' ||
      !localStorage.getItem('lineGraph_sort_end') ? new Date() : new Date(localStorage.getItem('lineGraph_sort_end'))
  });
  const [customNoFilingVsCompleteDates, setCustomNoFilingVsCompleteDates] = useState({
    customStart:
      localStorage.getItem('noFilingVsComplete_sort_start') === 'undefined' ||
      !localStorage.getItem('noFilingVsComplete_sort_start') ? dayjs().subtract(6, 'days').toDate() : new Date(localStorage.getItem('noFilingVsComplete_sort_start')),
    customEnd:
      localStorage.getItem('noFilingVsComplete_sort_end') === 'undefined' ||
      !localStorage.getItem('noFilingVsComplete_sort_end') ? new Date() : new Date(localStorage.getItem('noFilingVsComplete_sort_end'))
  });
  const [noFilingOwnerId, setNoFilingOwnerId] = useState(() => {
    const saved = localStorage.getItem('noFilingVsComplete_owner_id');

    if (!saved || saved === '0' || saved === 'undefined') return null;
    const n = Number(saved);
    return Number.isFinite(n) && n > 0 ? n : null;
  });
  const [customCompletedDates, setCustomCompletedDates] = useState({
    customStart: localStorage.getItem("completed_sort_start")
      ? new Date(localStorage.getItem("completed_sort_start"))
      : dayjs().subtract(6, "days").toDate(),
    customEnd: localStorage.getItem("completed_sort_end")
      ? new Date(localStorage.getItem("completed_sort_end"))
      : new Date(),
  });
  const [customAgeOfCaseDates, setCustomAgeOfCaseDates] = useState({
    customStart:
      localStorage.getItem("ageOfCases_sort_start") === "undefined" ||
      !localStorage.getItem("ageOfCases_sort_start")
        ? dayjs().subtract(90, "days").toDate()
        : new Date(localStorage.getItem("ageOfCases_sort_start")),
    customEnd:
      localStorage.getItem("ageOfCases_sort_end") === "undefined" ||
      !localStorage.getItem("ageOfCases_sort_end")
        ? new Date()
        : new Date(localStorage.getItem("ageOfCases_sort_end")),
  });
  const [widgetData, setWidgetData] = useState({
    bigNumbersWidgetData: null,
    activeSTRData: null,
    lineGraphData: null,
    workLoadWidgetData: null,
    noFilingVsCompletedData: null,
    ageOfCaseData: null,
    completedSTRData: null,
  });

  useEffect(() => {
    localStorage.setItem('noFilingVsComplete_owner_id', noFilingOwnerId ?? '0');
  }, [noFilingOwnerId]);

  useEffect(() => {
    const cur = widgetData?.noFilingVsCompletedData?.CurrentOwner;
    if (!noFilingOwnerId && cur?.OwnerId > 0) setNoFilingOwnerId(cur.OwnerId);
  }, [widgetData?.noFilingVsCompletedData?.CurrentOwner]);

  const fetchbigNumberData = () => fetchEndpointData(fetchbigNumbersWidgetData, (data) => {
    setWidgetData(prevData => ({ ...prevData, bigNumbersWidgetData: data }));
    setLoading(prevLoading => ({ ...prevLoading, isBigNumbersWidgetDataLoading: false }));
  });

  const fetchActiveSTRWidgetData = () => fetchEndpointData(fetchActiveSTRData, (data) => {
    setWidgetData(prevData => ({ ...prevData, activeSTRData: data }));
    setLoading(prevLoading => ({ ...prevLoading, isActiveSTRDataLoading: false }));
  });

  const fetchLineGraphData = (startDate = customDates.customStart, endDate = customDates.customEnd) => {
    if (!startDate || !endDate) return;
    setLoading(prevLoading => ({ ...prevLoading, isLineGraphLoading: true }));
    fetchSTRLineGraphData(startDate.toISOString(), endDate.toISOString())
      .then((result) => {
        if (result?.data) {
          setWidgetData(prevData => ({ ...prevData, lineGraphData: result.data }));
          setLoading(prevLoading => ({ ...prevLoading, isLineGraphLoading: false }));
        }
      })
      .finally(() => {
        setLoading((prev) => ({ ...prev, isLineGraphLoading: false }));
      });
  };

  const fetchNoFilingVsCompleteLineGraphData = (
    startDate = customNoFilingVsCompleteDates.customStart,
    endDate   = customNoFilingVsCompleteDates.customEnd,
    ownerId   = noFilingOwnerId
  ) => {
    if (!startDate || !endDate) return;
    setLoading(prev => ({ ...prev, isNoFilingVsCompletedLoading: true }));
    fetchSTRNoFilingVsCompleteLineGraphData(startDate.toISOString(), endDate.toISOString(), ownerId)
      .then((result) => {
        if (result?.data) {
          setWidgetData(prev => ({ ...prev, noFilingVsCompletedData: result.data }));
          setLoading(prev => ({ ...prev, isNoFilingVsCompletedLoading: false }));
        }
      })
      .finally(() => {
        setLoading((prev) => ({ ...prev, isNoFilingVsCompletedLoading: false }));
      });
  };

  const fetchWorkLoadWidgetData = () => fetchEndpointData(fetchWorkLoadData, (data) => {
    setWidgetData(prevData => ({ ...prevData, workLoadWidgetData: data }));
    setLoading(prevLoading => ({ ...prevLoading, isWorkLoadLoading: false }));
  });

  const fetchCompletedSTRWidgetData = (startDate = customCompletedDates.customStart, endDate = customCompletedDates.customEnd) => {
    if (!startDate || !endDate) return;
    setLoading(prev => ({ ...prev, isCompletedSTRLoading: true }));
    fetchCompletedSTRData(startDate.toISOString(), endDate.toISOString())
      .then((result) => {
        if (result?.data) {
          setWidgetData((prev) => ({ ...prev, completedSTRData: result.data }));
          setLoading((prev) => ({ ...prev, isCompletedSTRLoading: false }));
        }
      })
      .finally(() => {
        setLoading((prev) => ({
          ...prev,
          isCompletedSTRLoading: false,
        }));
      });
  };

  const fetchAgeOfCaseSTRWidgetData = (
    startDate = customAgeOfCaseDates.customStart,
    endDate = customAgeOfCaseDates.customEnd
  ) => {
    if (!startDate || !endDate) return;
    setLoading((prev) => ({ ...prev, isAgeOfCaseLoading: true }));
    fetchAgeOfCaseData(startDate.toISOString(), endDate.toISOString())
      .then((result) => {
        if (result?.data) {
          setWidgetData((prev) => ({
            ...prev,
            ageOfCaseData: result.data,
          }));
        }
      })
      .finally(() => {
        setLoading((prev) => ({
          ...prev,
          isAgeOfCaseLoading: false,
        }));
      });
  };


  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    fetchbigNumberData();
    fetchActiveSTRWidgetData();
    fetchLineGraphData(customDates.customStart, customDates.customEnd);
    fetchWorkLoadWidgetData();
    fetchNoFilingVsCompleteLineGraphData(customNoFilingVsCompleteDates.customStart, customNoFilingVsCompleteDates.customEnd);
    fetchCompletedSTRWidgetData(customCompletedDates.customStart, customCompletedDates.customEnd);
    fetchAgeOfCaseSTRWidgetData(
      customAgeOfCaseDates.customStart,
      customAgeOfCaseDates.customEnd,
    );
  };

  useEffect(() => {
    if (
      !loading.isBigNumbersWidgetDataLoading &&
      !loading.isActiveSTRDataLoading &&
      !loading.isLineGraphLoading &&
      !loading.isWorkLoadLoading &&
      !loading.isNoFilingVsCompletedLoading &&
      !loading.isCompletedSTRLoading &&
      !loading.isAgeOfCaseLoading
    ) {
      setLoading(prevLoading => ({ ...prevLoading, isLoading: false }));
    }
  }, [loading.isBigNumbersWidgetDataLoading, loading.isActiveSTRDataLoading, loading.isLineGraphLoading, loading.isWorkLoadLoading, loading.isNoFilingVsCompletedLoading, loading.isCompletedSTRLoading, loading.isAgeOfCaseLoading]);
  return (
    <>
      <Helmet>
        <title> TRIYO · Dashboard </title>
      </Helmet>
      {loading.isLoading ? (
        <PulseLoader style={{ marginTop: "50%" }} />
      ) : (
        <div className="configured-dashboard">
          <div
            className="configured-dashboard-container d-flex flex-column align-items-center"
            style={{ marginTop: "60px" }}
          >
            {widgetData.bigNumbersWidgetData && (
              <MetricCounter
                bigNumbersWidgetData={widgetData.bigNumbersWidgetData}
              />
            )}

            {widgetData.activeSTRData && widgetData.lineGraphData && (
              <div
                className="configured-dashboard table-wrapper mt d-flex justify-content-between"
                style={{ maxWidth: "1350px", width: "100%", marginTop: "30px" }}
              >
                <div
                  className="DoughnutChart-container"
                  style={{ flex: 1, marginRight: "15px" }}
                >
                  <DoughnutChart data={widgetData.activeSTRData} />
                </div>
                <div
                  className="NotStartedVsCompleted-container"
                  style={{ flex: 1 }}
                >
                  <NotStartedVsCompletedLineGraph
                    data={widgetData.lineGraphData}
                    fetchData={fetchLineGraphData}
                    customStart={customDates.customStart}
                    customEnd={customDates.customEnd}
                    setCustomStart={(start) =>
                      setCustomDates((prev) => ({
                        ...prev,
                        customStart: start,
                      }))
                    }
                    setCustomEnd={(end) =>
                      setCustomDates((prev) => ({ ...prev, customEnd: end }))
                    }
                  />
                </div>
              </div>
            )}

            {widgetData.completedSTRData &&
              widgetData.noFilingVsCompletedData && (
                <div
                  className="configured-dashboard table-wrapper mt d-flex justify-content-between"
                  style={{
                    maxWidth: "1350px",
                    width: "100%",
                    marginTop: "30px",
                  }}
                >
                  <div
                    className="DoughnutChart-container"
                    style={{ flex: 1, marginRight: "15px" }}
                  >
                    <CompletedSTRsBarGraph
                      data={widgetData.completedSTRData}
                      fetchData={fetchCompletedSTRWidgetData}
                      customStart={customCompletedDates.customStart}
                      customEnd={customCompletedDates.customEnd}
                      setCustomStart={(start) =>
                        setCustomCompletedDates((p) => ({
                          ...p,
                          customStart: start,
                        }))
                      }
                      setCustomEnd={(end) =>
                        setCustomCompletedDates((p) => ({
                          ...p,
                          customEnd: end,
                        }))
                      }
                    />
                  </div>
                  <div
                    className="NotStartedVsCompleted-container"
                    style={{ flex: 1 }}
                  >
                    <NoFilingVsCompletedLineGraph
                      data={widgetData.noFilingVsCompletedData}
                      fetchData={(s, e, ownerId) => {
                        setNoFilingOwnerId(ownerId ?? null);
                        fetchNoFilingVsCompleteLineGraphData(s, e, ownerId);
                      }}
                      customStart={customNoFilingVsCompleteDates.customStart}
                      customEnd={customNoFilingVsCompleteDates.customEnd}
                      setCustomStart={(start) =>
                        setCustomNoFilingVsCompleteDates((prev) => ({
                          ...prev,
                          customStart: start,
                        }))
                      }
                      setCustomEnd={(end) =>
                        setCustomNoFilingVsCompleteDates((prev) => ({
                          ...prev,
                          customEnd: end,
                        }))
                      }
                      selectedOwnerId={noFilingOwnerId}
                      setSelectedOwnerId={setNoFilingOwnerId}
                    />
                  </div>
                </div>
              )}

            {widgetData.ageOfCaseData && (
              <div
                className="configured-dashboard table-wrapper mt d-flex justify-content-between"
                style={{ maxWidth: "1350px", width: "100%", marginTop: "30px" }}
              >
                <div className="AgeOfCase-container" style={{ flex: 1 }}>
                  <AgeOfCasesLineGraph
                    data={widgetData.ageOfCaseData}
                    fetchData={fetchAgeOfCaseSTRWidgetData}
                    customStart={customAgeOfCaseDates.customStart}
                    customEnd={customAgeOfCaseDates.customEnd}
                    setCustomStart={(start) =>
                      setCustomAgeOfCaseDates((prev) => ({
                        ...prev,
                        customStart: start,
                      }))
                    }
                    setCustomEnd={(end) =>
                      setCustomAgeOfCaseDates((prev) => ({
                        ...prev,
                        customEnd: end,
                      }))
                    }
                  />
                </div>
              </div>
            )}

            {widgetData.workLoadWidgetData && (
              <div className="margin-top-30">
                <WorkLoadWidget data={widgetData.workLoadWidgetData} />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ConfiguredDashboard;
